import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';


const Menu = () => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [vendorsOpen, setVendorsOpen] = useState(false);
  const [nameMenuOpen, setNameMenuOpen] = useState(false); // <-- FIXED useState issue
  const navigate = useNavigate();

  // Check if user is logged in by presence of token in localStorage
  const isLoggedIn = !!localStorage.getItem('token');

  const handleSettingsClick = () => {
    setSettingsOpen(!settingsOpen);
  };

    const handleVendorsClick = () => {
    setVendorsOpen(!vendorsOpen);
  };

  return (
    <>
      <nav style={styles.nav}>
        <div style={styles.headerRow}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {/* Removed first name of the user from the top of the menu */}
            <div
              style={styles.siteTitle}
              onClick={() => navigate('/')}
            >
              <img
                src="community.png"
                alt="Jaca Logo"
                style={{ height: '28px', verticalAlign: 'middle', marginRight: '10px' }}
              />
              Jaca - Just a click away - try <a href='/ai'>AI Mode!</a>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '18px' }}>
            {(() => {
              const user = JSON.parse(localStorage.getItem('user') || '{}');
              // Hide Become a Service Provider if user_type is 3 (vendor)
              if (user.user_type === 3) return null;
              return (
                <div style={styles.topBar}>
                  <span
                    style={styles.providerLink}
                    onClick={() => navigate('/vendorsignup')}
                  >
                    Become a STEM Coach
                  </span>
                </div>
              );
            })()}
          </div>
        </div>
        <ul style={styles.ul}>
          {!isLoggedIn ? (
            <>
              <li style={styles.li} onClick={() => navigate('/signin')}>
                <i className="fas fa-sign-in-alt" style={styles.icon}></i> Sign In
              </li>
              <li style={styles.li} onClick={() => navigate('/signup')}>
                <i className="fas fa-user-plus" style={styles.icon}></i> Sign Up
              </li>
            </>
          ) : (
            <>
              <li
                style={styles.li}
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  if (user.user_type === 3) {
                    navigate(`/vendordashboard?user_id=${user.id}`);
                  } else if (user.user_type === 1) {
                    navigate('/customerdashboard');
                  } else {
                    navigate('/');
                  }
                }}
              >
                {/* Remove Home menu if orientation or background check is not complete */}
                {(() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  if (
                    user.user_type === 3 &&
                    (!user.is_orientation_complete || !user.is_background_checked)
                  ) {
                    return null;
                  }
                  return (
                    <>
                      <i className="fas fa-home" style={styles.icon}></i> Home
                    </>
                  );
                })()}
              </li>
              {/* First name menu item for user_type == 1, between Home and Settings */}
              {(() => {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                if (user.user_type === 1 && user.firstName) {
                  return (
                    <li
                      style={{
                        ...styles.li,
                        color: '#388e3c',
                        background: '#fffde4',
                        boxShadow: '0 1px 4px #e0cfa0',
                        fontWeight: 'bold',
                        fontSize: '1rem',
                        cursor: 'pointer',
                        position: 'relative',
                      }}
                      onClick={() => setNameMenuOpen(!nameMenuOpen)}
                      onBlur={() => setNameMenuOpen(false)}
                      tabIndex={0}
                    >
                      <i className="fas fa-user" style={styles.icon}></i> {user.firstName}
                      {nameMenuOpen && (
                        <ul style={styles.submenu} onMouseLeave={() => setNameMenuOpen(false)}>
                          {/* <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/profile');
                            }}
                          >
                            <i className="fas fa-user" style={styles.icon}></i> Profile
                          </li> */}
                          <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/appointments');
                            }}
                          >
                            <i className="fas fa-calendar-check" style={styles.icon}></i> Appointments
                          </li>
                          <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/customerdashboard');
                            }}
                          >
                            <i className="fas fa-tachometer-alt" style={styles.icon}></i> Dashboard
                          </li>
                          <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/invoices');
                            }}
                          >
                            <i className="fas fa-file-invoice-dollar" style={styles.icon}></i> Invoices
                          </li>
                          <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/search');
                            }}
                          >
                            <i className="fas fa-search" style={styles.icon}></i> Search
                          </li>
                          <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/inbox');
                            }}
                          >
                            <i className="fas fa-envelope" style={styles.icon}></i> Mail
                          </li>
                          <li
                            style={styles.subli}
                            onClick={() => {
                              setNameMenuOpen(false);
                              navigate('/feedback');
                            }}
                          >
                            <i className="fas fa-comment-dots" style={styles.icon}></i> Feedback
                          </li>
                        </ul>
                      )}
                    </li>
                  );
                }
                return null;
              })()}
              {(() => {
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                // Only show Vendor dropdown if orientation and background check are complete
                if (
                  user.user_type === 3 &&
                  user.is_orientation_complete === 1 &&
                  user.is_background_checked === 1  
                ) {
                  return (
                    <li
                      style={styles.li}
                      onClick={handleVendorsClick}
                      onBlur={() => setVendorsOpen(false)}
                      tabIndex={0}
                    >
                      <span>
                        <i className="fas fa-store" style={styles.icon}></i> Coaching
                      </span>
                      {vendorsOpen && (
                        <ul style={styles.submenu} onMouseLeave={() => setVendorsOpen(false)}>
                          <li style={styles.subli} onClick={() => navigate('/vendorappointments')}>
                            <i className="fas fa-calendar-check" style={styles.icon}></i> Appointments
                          </li>
                          <li style={styles.subli} onClick={() => navigate('/vendorschedules')}>
                            <i className="fas fa-clock" style={styles.icon}></i> Schedules
                          </li>
                          <li style={styles.subli} onClick={() => navigate('/vendorinvoices')}>
                            <i className="fas fa-file-invoice" style={styles.icon}></i> Invoices
                          </li>
                          <li style={styles.subli} onClick={() => navigate('/vendorratings')}>
                            <i className="fas fa-star" style={styles.icon}></i> Customer Ratings
                          </li>
                          <li style={styles.subli} onClick={() => navigate('/inbox')}>
                            <i className="fas fa-star" style={styles.icon}></i> Inbox
                          </li>
                           <li style={styles.subli} onClick={() => navigate('/vendorcashout')}>
                            <i className="fas fa-star" style={styles.icon}></i> Cash Out
                          </li>
                          <li style={styles.subli} onClick={() => navigate('/vendordescription')}>
                            <i className="fas fa-info-circle" style={styles.icon}></i> Description
                          </li>
                        </ul>
                      )}
                    </li>
                  );
                }
                return null;
              })()}
              <li
                style={styles.li}
                onClick={handleSettingsClick}
                onBlur={() => setSettingsOpen(false)}
                tabIndex={0}
              >
                <span>
                  <i className="fas fa-cog" style={styles.icon}></i> Settings
                </span>
                {settingsOpen && (
                  <ul
                    style={styles.submenu}
                    onMouseLeave={() => setSettingsOpen(false)}
                  >
                    <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/profile'); }}>
                      <i className="fas fa-user" style={styles.icon}></i> Profile
                    </li>
                    {/* Show Credit Cards only for customers (user_type === 1) */}
                    {(() => {
                      const user = JSON.parse(localStorage.getItem('user') || '{}');
                      if (user.user_type === 1) {
                        return (
                          <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/creditcards'); }}>
                            <i className="fas fa-credit-card" style={styles.icon}></i> Credit Cards
                          </li>
                        );
                      }
                      return null;
                    })()}
                    {/* <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/photos'); }}>
                      <i className="fas fa-image" style={styles.icon}></i> Photos
                    </li> */}
                    {/* <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/adddress'); }}>
                      <i className="fas fa-map-marker-alt" style={styles.icon}></i> Address
                    </li> */}
                    {/* Add AdminPage link if usertype == 2 */}
                    {(() => {
                      const user = JSON.parse(localStorage.getItem('user') || '{}');
                      if (user.user_type === 2) {
                        return (
                          <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/admin'); }}>
                            <i className="fas fa-user-shield" style={styles.icon}></i> Admin Page
                          </li>
                        );
                      }
                      return null;
                    })()}
                      {/* Add MoneyOut link for admin users (user_type == 2) */}
                      {(() => {
                        const user = JSON.parse(localStorage.getItem('user') || '{}');
                        if (user.user_type === 2) {
                          return (
                            <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/moneyout'); }}>
                              <i className="fas fa-money-bill-wave" style={styles.icon}></i> MoneyOut
                            </li>
                          );
                        }
                        return null;
                      })()}
                      {(() => {
                      const user = JSON.parse(localStorage.getItem('user') || '{}');
                      if (user.user_type === 2) {
                        return (
                          <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/admin/feedback'); }}>
                            <i className="fas fa-user-shield" style={styles.icon}></i> Feedback
                          </li>
                        );
                      }
                      return null;
                    })()}
                    <li style={styles.subli} onClick={() => { setSettingsOpen(false); navigate('/logout'); }}>
                      <i className="fas fa-sign-out-alt" style={styles.icon}></i> Log Out
                    </li>
                  </ul>
                )}
              </li>
            </>
          )}
        </ul>
        {/* Footer section for Help and About Us */}
        {/* <div style={{ textAlign: 'center', marginTop: '32px', marginBottom: '8px', fontSize: '1rem' }}>
          <span
            style={{
              color: '#4078c0',
              fontWeight: 'bold',
              cursor: 'pointer',
              textDecoration: 'underline',
              marginRight: '18px',
            }}
            onClick={() => navigate('/help')}
          >
            Help
          </span>
          <span
            style={{
              color: '#4078c0',
              fontWeight: 'bold',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={() => navigate('/about')}
          >
            About Us
          </span>
        </div> */}
      </nav>
    </>
  );
};

const styles = {
  nav: {
    background: 'linear-gradient(90deg, #f5f6fa 0%, #eaeaea 100%)',
    padding: '12px 0 0 0',
    marginBottom: '32px',
    boxShadow: '0 2px 8px rgba(191,167,122,0.10)',
    borderBottom: '2px solid #d8c3a5',
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px',
    padding: '0 32px',
  },
  siteTitle: {
    fontWeight: 'bold',
    fontSize: '1rem', // smaller font size
    color: '#111', // changed from blue/green to black
    letterSpacing: '0.5px',
    textShadow: '0 1px 2px #eaeaea',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  topBar: {
    textAlign: 'center',
    color: '#2e7d32',
    fontWeight: 'bold',
    fontSize: '1rem', // smaller font size
    letterSpacing: '0.5px',
    padding: '4px 0',
    background: 'rgba(255,255,255,0.25)',
    borderRadius: '8px 8px 0 0',
  },
  providerLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: '#8d6e36',
    transition: 'color 0.2s',
  },
  ul: {
    display: 'flex',
    justifyContent: 'center',
    listStyle: 'none',
    margin: 0,
    padding: '8px 0',
    gap: '16px',
  },
  li: {
    color: '#4e3b1f',
    margin: '0 18px',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '18px',
    position: 'relative',
    transition: 'color 0.2s, background 0.2s',
    padding: '8px 18px',
    borderRadius: '6px',
    background: 'rgba(255,255,255,0.15)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  icon: {
    marginRight: '6px',
    fontSize: '16px',
    color: '#8d6e36',
  },
  submenu: {
    position: 'absolute',
    top: '44px',
    left: 0,
    background: '#f7ecd0',
    listStyle: 'none',
    margin: 0,
    padding: '8px 0',
    borderRadius: '8px',
    minWidth: '180px',
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(191,167,122,0.15)',
  },
  subli: {
    color: '#4e3b1f',
    padding: '10px 20px',
    cursor: 'pointer',
    fontWeight: 'normal',
    fontSize: '16px',
    transition: 'background 0.2s',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};



export default Menu;